import React from "react";

export default function Cart({
  width = "45",
  height = "45",
  stroke = "#606f7b",
  fill = "#f8fafc"
}) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45 45"
      width={width}
      height={height}
    >
      <g id="Canvas" fill="none">
        <g id="Vector">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M 41.5649 10.759L 41.5649 11.952L 41.5649 11.9888L 41.5578 12.0249L 38.7152 26.3718C 38.5227 27.3599 37.6609 28.0737 36.658 28.067L 14.4825 28.067L 14.1469 28.067L 14.1098 27.7335L 11.457 3.89164L 11.417 3.76441L 11.4162 3.76196L 11.4162 3.76196C 10.7983 1.74758 8.95121 0.375 6.86634 0.375L 0.375 0.375L 0.375 3.08704L 6.86634 3.08704C 7.77875 3.08704 8.53787 3.6864 8.83001 4.52915L 8.84377 4.56884L 8.84841 4.61059L 12.0493 33.4366C 12.0493 33.4369 12.0494 33.4372 12.0494 33.4376C 12.3336 35.875 14.3767 37.7094 16.8034 37.715L 16.85 38.462C 15.2574 38.6649 14.0858 40.0722 14.1697 41.6946C 14.2556 43.3158 15.5645 44.591 17.1665 44.625C 18.8421 44.623 20.22 43.2367 20.22 41.538C 20.22 39.9574 19.0249 38.6338 17.4722 38.4627L 17.5133 37.715L 33.9634 37.715L 34.0109 38.462C 32.4204 38.6648 31.2486 40.0721 31.3326 41.6946C 31.4165 43.3155 32.727 44.591 34.3274 44.625C 36.005 44.623 37.3828 43.2365 37.3828 41.538C 37.3828 39.9584 36.1887 38.6341 34.6197 38.4627L 34.6604 37.715L 37.3828 37.715L 37.3828 35.005L 16.8059 35.005C 15.7335 35.0228 14.8302 34.2112 14.7242 33.1408C 14.7242 33.1401 14.7241 33.1393 14.724 33.1386L 14.511 31.1949L 14.4655 30.7791L 14.8838 30.7791L 36.6594 30.7791C 38.9146 30.7791 40.8978 29.1489 41.3429 26.9171M 41.343 26.9167L 44.5435 10.759L 41.5649 10.759"
            fill={fill}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M 41.5649 10.759L 41.5649 11.952L 41.5649 11.9888L 41.5578 12.0249L 38.7152 26.3718C 38.5227 27.3599 37.6609 28.0737 36.658 28.067L 14.4825 28.067L 14.1469 28.067L 14.1098 27.7335L 11.457 3.89164L 11.417 3.76441L 11.4162 3.76196L 11.4162 3.76196C 10.7983 1.74758 8.95121 0.375 6.86634 0.375L 0.375 0.375L 0.375 3.08704L 6.86634 3.08704C 7.77875 3.08704 8.53787 3.6864 8.83001 4.52915L 8.84377 4.56884L 8.84841 4.61059L 12.0493 33.4366C 12.0493 33.4369 12.0494 33.4372 12.0494 33.4376C 12.3336 35.875 14.3767 37.7094 16.8034 37.715L 16.85 38.462C 15.2574 38.6649 14.0858 40.0722 14.1697 41.6946C 14.2556 43.3158 15.5645 44.591 17.1665 44.625C 18.8421 44.623 20.22 43.2367 20.22 41.538C 20.22 39.9574 19.0249 38.6338 17.4722 38.4627L 17.5133 37.715L 33.9634 37.715L 34.0109 38.462C 32.4204 38.6648 31.2486 40.0721 31.3326 41.6946C 31.4165 43.3155 32.727 44.591 34.3274 44.625C 36.005 44.623 37.3828 43.2365 37.3828 41.538C 37.3828 39.9584 36.1887 38.6341 34.6197 38.4627L 34.6604 37.715L 37.3828 37.715L 37.3828 35.005L 16.8059 35.005C 15.7335 35.0228 14.8302 34.2112 14.7242 33.1408C 14.7242 33.1401 14.7241 33.1393 14.724 33.1386L 14.511 31.1949L 14.4655 30.7791L 14.8838 30.7791L 36.6594 30.7791C 38.9146 30.7791 40.8978 29.1489 41.3429 26.9171M 41.343 26.9167L 44.5435 10.759L 41.5649 10.759"
            strokeWidth="0.75"
            strokeMiterlimit="8"
            stroke={stroke}
          />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/Icons/Cart.js